<template>
  <div>
    <v-container fluid>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <v-card class="box">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Canteen Approve</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-row justify="center" dense>
          <v-col cols="12" sm="2">
            <p><v-icon color="error">*</v-icon><b>Academic Year</b></p>
            <v-autocomplete
              color="#0F2027"
              dense
              rounded
              required
              v-model="ay"
              :items="ay_list"
              item-text="ay"
              item-value="id"
              label="Academic Year"
              outlined
              persistent-hint
              hint="Please Select Academic Year"
              @change="getInstallmentData()"
            />
          </v-col>
          <v-col cols="12" sm="2">
            <p><b>Standard</b></p>
            <v-autocomplete
              color="#0F2027"
              dense
              rounded
              required
              v-model="standard"
              :items="standard_list"
              item-text="standard"
              item-value="id"
              label="Standard"
              outlined
              persistent-hint
              hint="Please Select Standard"
            />
          </v-col>
          <v-col cols="12" sm="2">
            <p><b>Approval Status</b></p>
            <v-autocomplete
              color="#0F2027"
              dense
              rounded
              required
              v-model="canteen_status"
              :items="canteen_status_list"
              item-text="status"
              item-value="id"
              label="Canteen Approval Status"
              outlined
              persistent-hint
              hint="Please Select Status"
            />
          </v-col>
          <v-col cols="12" sm="2" v-if="canteen_installment_list!=''">
            <p><b>Installment</b></p>
            <v-autocomplete
              color="#0F2027"
              dense
              rounded
              required
              v-model="canteen_installment"
              :items="canteen_installment_list"
              item-text="name"
              item-value="id"
              label="Canteen Installment"
              outlined
              persistent-hint
              hint="Please Select Installment"
            />
          </v-col>
          <v-col cols="12" sm="3" v-if="all_learner_list!=''">
            <p><b>Learner</b></p>
            <v-autocomplete
              color="#0F2027"
              dense
              rounded
              required
              v-model="learner"
              :items="all_learner_list"
              item-text="learner"
              item-value="id"
              label="Student"
              outlined
              persistent-hint
              hint="Please Select Student"
            />
          </v-col>
        </v-row>
        <!-- //v-if="this.canteen_installment && this.canteen_status && this.learner"> -->
        <v-row justify="center" dense>
          <v-col cols="12" sm="2" md="2"></v-col>
          <v-col col="12" sm="4" md="4">
            <v-btn color="warning" @click="fetch()">Fetch</v-btn>
          </v-col>
        </v-row>
      </v-card>

       <span v-if="canteen_fee_sync != true">
      <v-card
        class="box"
        v-if="learner_canteen_fees_installment_details.length > 0"
      >
        <v-data-table
          :headers="headers"
          :items="learner_canteen_fees_installment_details"
          :search="search"
        >
          <template v-slot:top>
            <v-toolbar flat class="toolbar">
              <v-toolbar-title>List</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-toolbar>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <div v-if="item.is_blocked_for_canteen==false"> 
              <v-avatar size="35">
                <v-icon
                  class="mr-4 v-icon-size"
                  color="green"
                  @click="editItem(item)"
                  >mdi-application-export</v-icon
                >
              </v-avatar>
            </div>
             <div v-else>
              <b style="color:red">Student Is Blocked For Canteen Facility</b></div>
          </template>
          <template v-slot:[`item.history`]="{ item }">
            <div>
              <v-avatar size="35">
                <v-icon
                  class="mr-4 v-icon-size"
                  color="red"
                  @click="getArrovalHistory(item)"
                  >mdi-eye</v-icon
                >
              </v-avatar>
            </div>
          </template>
        </v-data-table>
      </v-card>
       </span>
        <span v-else>
      <v-card
        class="box"
        v-if="learner_canteen_fees_installment_details.length > 0"
      >
        <v-data-table
          :headers="headers_2"
          :items="learner_canteen_fees_installment_details"
          :search="search"
        >
          <template v-slot:top>
            <v-toolbar flat class="toolbar">
              <v-toolbar-title>List</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-toolbar>
          </template>
          <!-- <template v-slot:[`item.action`]="{ item }">
            <div v-if="item.is_blocked_for_canteen==false"> 
              <v-avatar size="35">
                <v-icon
                  class="mr-4 v-icon-size"
                  color="green"
                  @click="editItem(item)"
                  >mdi-application-export</v-icon
                >
              </v-avatar>
            </div>
             <div v-else>
              <b style="color:red">Student Is Blocked For Canteen Facility</b></div>
          </template> -->

           <template v-slot:[`item.action`]="{ item }">
            <div v-if="item.is_blocked_for_canteen==false && item.is_canteen_sync==false">
                <v-btn color="warning" @click="markApprove(item)">Approve</v-btn>
              <!-- <v-avatar size="35">
                <v-icon
                  class="mr-4 v-icon-size"
                  color="green"
                  @click="markApprove(item)"
                  >mdi-account-check</v-icon
                >
              </v-avatar> -->
            </div>
             <div v-else-if="item.is_canteen_sync==true">
               <b>Already Synced...</b>
             </div>
             <div v-else>
              <b>Student Is Blocked For Canteen Facility...</b>
            </div>
          </template>
          
        </v-data-table>
      </v-card>
       </span>

      <v-dialog v-model="show_approve_transport_card" fullscreen>
        <v-card>
          <v-toolbar class="toolbar no-display" flat dense>
            <v-btn icon dark @click="show_approve_transport_card = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>
              <strong> Details </strong>
            </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card class="box">
            <v-row justify="center" dense>
              <v-col cols="12" sm="2">
                <p><b>PRN</b></p>
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="child_details.registration_number"
                  readonly
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <p><b>Student Name</b></p>
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="child_details.learner"
                  readonly
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="2">
                <p><b>Standard</b></p>
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="child_details.standard"
                  readonly
                  filled
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card>
          <v-card class="box">
            <v-row justify="center" dense>
              <v-col cols="12" sm="2">
                <p><b>Total Fees In Rs.</b></p>
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="child_details.applicable_fees"
                  readonly
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="2">
                <p><b>Installment Name</b></p>
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="child_details.canteen_installment"
                  readonly
                  filled
                ></v-text-field>
              </v-col>
            </v-row>
            <!-- {{is_final_approved}} -->
            <v-row justify="center" dense>
              <v-col cols="12" sm="2">
                <p><b>Action</b></p>
                <v-autocomplete
                  color="#0F2027"
                  dense
                  rounded
                  required
                  v-model="canteenstatus"
                  :items="canteen_status_list"
                  item-text="status"
                  item-value="id"
                  label="Status"
                  hint="Select Your Approval"
                  outlined
                  persistent-hint
                />
              </v-col>
              <v-col cols="12" sm="2">
                <p><b>Remark</b></p>
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="approve_remark"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row justify="center" dense v-if="canteenstatus">
              <v-btn color="warning" @click="saveApproveStatus()">Save</v-btn>
            </v-row>
          </v-card>
        </v-card>
      </v-dialog>
      <v-dialog v-model="show_approve_history_card" fullscreen>
        <v-card>
          <v-toolbar class="toolbar no-display" flat dense>
            <v-btn icon dark @click="show_approve_history_card = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>
              <strong> Canteen Approval History </strong>
            </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card class="box">
            <v-row justify="center" dense>
              <v-col cols="12" sm="2">
                <p><b>PRN</b></p>
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="canteenApplicationsDetails.registration_number"
                  readonly
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <p><b>Student Name</b></p>
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="canteenApplicationsDetails.learner"
                  readonly
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="2">
                <p><b>Standard</b></p>
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="canteenApplicationsDetails.standard"
                  readonly
                  filled
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row justify="center" dense>
              <v-col cols="12" sm="2">
                <p><b>Academic Year</b></p>
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="canteenApplicationsDetails.academicyear"
                  readonly
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <p><b>Total Fees Applicable In Rs.</b></p>
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="canteenApplicationsDetails.totalfees"
                  readonly
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="2">
                <p><b>Canteen Installment</b></p>
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="canteenApplicationsDetails.canteen_installment"
                  readonly
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="2">
                <p><b>Installment Fees Applicable In Rs</b></p>
                <!-- <br /> -->
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="
                    canteenApplicationsDetails.canteen_installment_amount
                  "
                  readonly
                  filled
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card>

          <v-card class="box" v-if="canteenApprovalDetails.length > 0">
            <v-data-table
              :headers="headers_history"
              :items="canteenApprovalDetails"
            >
              <template v-slot:top>
                <v-toolbar flat class="toolbar">
                  <v-toolbar-title>Canteen Approval History</v-toolbar-title>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <v-spacer></v-spacer>
                </v-toolbar>
              </template>
              <template v-slot:[`item.is_last_approval`]="{ item }">
                <span v-if="item.is_last_approval">
                  <v-icon class="mr-2 v-icon-size" color="success"
                    >mdi-check-circle-outline</v-icon
                  >
                </span>
                <span v-else>
                  <v-icon class="mr-2 v-icon-size" color="error"
                    >mdi-close-circle-outline</v-icon
                  >
                </span>
              </template>
            </v-data-table>
          </v-card>
          <v-card v-else>
            <br />
            <v-row justify="center">
              <strong color="red">No action taken yet...</strong>
            </v-row>
          </v-card>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
  <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  data: () => ({
    search: "",
    is_final_approved: false,
    loader: false,
    snackbar_msg: "",
    color: "",
    snackbar: false,
    overlay: false,
    ay_list: [],
    ay: "",
    standard_list: [],
    standard: "",
    canteen_status_list: [],
    canteen_status: "",
    canteen_installment_list: [],
    canteen_installment: "",
    all_learner_list: [],
    learner: "",
    learner_canteen_fees_installment_details: [],
    show_approve_transport_card: false,
    child_details: {
      lid: "",
      registration_number: "",
      learner: "",
      standard: "",
      academicYear: "",
      totalfees: "",
      paid_till_now: "",
      applicable_fees: "",
      canteen_installment_amount: "",
      canteen_installment: "",
    },
    totalfees_approved: "",

    canteen_installment_list: [],
    canteeninstallment: "",
    canteen_status_list: [],
    canteenstatus: "",
    approve_remark: "",
    learnercanteenfeesinstallment: "",
    canteenApprovalDetails: [],
    show_approve_history_card: false,
    canteenApplicationsDetails: [],
    learner_canteen_fees_installment_id: "",
    headers: [
      { text: "SR No", value: "srno" },
      // { text: "PRN", value: "prn" },
      { text: "Student", value: "name" },
      { text: "Installment", value: "canteeninstallment" },
      // { text: "Fees In Rs", value: "totalfees" },
      { text: "Amount To Pay", value: "amount" },
      { text: "Paid Till Now", value: "paid_till_now" },
      { text: "Your Approval Status", value: "your_status" },
      { text: "Final Approval Status", value: "canteenapprovalstatus" },
      { text: "Action", value: "action" },
      { text: "My Approval Status", value: "history" },
    ],
     headers_2: [
      { text: "SR No", value: "srno" },
      // { text: "PRN", value: "prn" },
      { text: "Student", value: "name" },
      // { text: "Installment", value: "canteeninstallment" },
      // { text: "Fees In Rs", value: "totalfees" },
      { text: "Amount To Pay", value: "totalfees" },
      // { text: "Paid Till Now", value: "paid_till_now" },
      // { text: "Your Approval Status", value: "your_status" },/
      // { text: "Final Approval Status", value: "canteenapprovalstatus" },
      { text: "Action", value: "action" },
      // { text: "My Approval Status", value: "history" },
    ],
    headers_history: [
      { text: "SR No", value: "count" },
      { text: "Authority", value: "canteenapprovalhierarchy" },
      { text: "Authority Level", value: "authority_level" },
      { text: "Is Last Authority", value: "is_last_approval" },
      { text: "Application Date", value: "application_push_date" },
      { text: "Action Date", value: "application_action_date" },
      { text: "Status", value: "canteenapprovalstatus" },
      { text: "Remark", value: "remark" },
    ],
    canteen_fee_sync:false
  }),
  methods: {
      markApprove(item){
          if (!confirm("Are You Sure You Want To Approve Request...?")) return;
          const data = {
              learner_canteen_fees_installment: item.id,
              learner_id: item.learner_id, 
              ay:this.ay
          };
          this.overlay = true;
          axios
              .post("/Canteen/markCanteenRequestApprove", data)
              .then((res) => {
              if (res.data.flag == "YES") {
                  // this.learner_transport_fees_installment_details =res.data.learner_transport_fees_installment_details;
                  this.fetch()
                  this.showSnackbar("green", "Request Is Approved");
              } else if (res.data.flag == "No") {
                  this.showSnackbar("red", res.data.snackbar);
              } else {
                  this.showSnackbar("red", res.data.snackbar);
                  sessionStorage.setItem("error-trace", res.data.error_trace);
              }
              this.overlay = false;
              })
              .catch((error) => {
              this.onerror(error);

              this.overlay = false;
              })
              .finally(() => {
              this.overlay = false;
              });
             },
    getInstallmentData(){
      this.canteen_installment_list=[],
      this.all_learner_list=[], this.learner_canteen_fees_installment_details =[]
       const data = {
        academicYear: this.ay
      };
      this.overlay = true;
      axios
        .post("/Canteen/getInstallmentDataByAy", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.canteen_installment_list = res.data.canteen_installment_list;
            this.all_learner_list = res.data.all_learner_list;
            if(this.canteen_installment_list==''){
                this.showSnackbar("red", "Installment List Not Defined For This Academicyear...");    
                return
            }           
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    getArrovalHistory(item) {
      const data = {
        learnercanteenfeesinstallment: item.id,
      };
      this.overlay = true;
      axios
        .post("/Canteen/getCanteenArrovalHistory", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.canteenApprovalDetails = res.data.canteenApprovalDetails;
            this.canteenApplicationsDetails =
              res.data.canteenApplicationsDetails[0];
            this.show_approve_history_card = true;
            // this.showSnackbar("green", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    saveApproveStatus() {
      if (!confirm("Are You Sure You Want To Save...?")) return;
      if (this.canteenstatus == null || this.canteenstatus == "") {
        this.showSnackbar("red", "Please Select Status");
        return;
      }
      const data = {
        learnercanteenfeesinstallment: this.learnercanteenfeesinstallment,
        canteenstatus: this.canteenstatus,
        remark: this.approve_remark,
        canteeninstallment: this.canteeninstallment,
        total_fees: this.applicable_fees,
      };
      this.overlay = true;
      axios
        .post("/Canteen/saveApproveStatusLevelOne", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            (this.show_approve_transport_card = false), this.fetch();
            this.showSnackbar("green", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    editItem(item) {
      this.canteenstatus = "";
      this.learner_canteen_fees_installment_id = item.id;
      const data = {
        learner_canteen_fees_installment: item.id,
      };
      this.overlay = true;
      axios
        .post("/Canteen/fetchCanteenApplicationsDetails", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            //this.showSnackbar("green", res.data.snackbar);
            this.child_details.registration_number =
              res.data.registration_number;
            this.child_details.learner = res.data.learner;
            this.child_details.lid = res.data.lid;
            this.child_details.standard = res.data.standard;
            this.child_details.academicYear = res.data.academicYear;
            this.child_details.totalfees = res.data.totalfees;
            this.child_details.applicable_fees = res.data.applicable_fees;
            this.child_details.paid_till_now = res.data.paid_till_now;
            this.child_details.canteen_installment_amount =
              res.data.canteen_installment_amount;
            this.child_details.canteen_installment =
              res.data.canteen_installment;

            this.canteen_installment_list = res.data.canteen_installment_list;
            this.canteen_status_list = res.data.canteen_status_list;
            //this.canteeninstallment=res.data.canteen_installment_id
            this.learnercanteenfeesinstallment =
              res.data.learnercanteenfeesinstallment;
            this.is_final_approved = res.data.is_final_approved;
            this.show_approve_transport_card = true;
            // this.learner_canteen_fees_installment_details=res.data.learner_canteen_fees_installment_details
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    fetch() {
       if(this.standard==''){
          this.showSnackbar("red","Please Select Standard");
            return
      }
      if(this.canteen_status==''){
          this.showSnackbar("red","Please Select Status");
            return
      }
       if(this.canteen_installment==''){
          this.showSnackbar("red","Please Select Installment");
            return
      }
      if(this.learner==''){
          this.showSnackbar("red","Please Select Students");
          return
      }
      const data = {
        academicYear: this.ay,
        learner: this.learner,
        canteen_status: this.canteen_status,
        canteen_installment: this.canteen_installment,
        standard: this.standard,
      };
      this.overlay = true;
      axios
        .post("/Canteen/fetchCanteenApplications", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            //this.showSnackbar("green", res.data.snackbar);
            this.learner_canteen_fees_installment_details =res.data.learner_canteen_fees_installment_details;
            this.canteen_fee_sync=res.data.canteen_fee_sync
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    onLoad() {
      axios
        .post("Canteen/approveTCanteenApplication")
        .then((res) => {
          if (res.data.flag == "YES") {
            (this.ay_list = res.data.ay_list), (this.ay = res.data.curreny_ay);
            this.standard_list = res.data.standard_list;
            this.canteen_status_list = res.data.canteen_status_list;
            this.canteen_installment_list = res.data.canteen_installment_list;
            this.all_learner_list = res.data.all_learner_list;
            this.overlay = false;
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong!!!");
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
  mounted() {
    this.onLoad();
  },
  watch: {},
};
</script>
<style scoped>
</style>